import script from "./LeadDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadDetails.vue?vue&type=script&setup=true&lang=js"

import "./LeadDetails.vue?vue&type=style&index=0&id=c52802c2&scoped=true&lang=css"

import exportComponent from "/builds/izee/leadservice/lead-admin-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c52802c2"]])

export default __exports__